import { IQuery, IQueryMediator } from 'core-ts-types';

import { APGenericSlot } from '../../../../global/builders/ap_generic_slot_builder';

import * as _4 from 'lodash4';
import { ICommentsDatasource } from '../../../../comments/datasources/comments_datasource';
import { APCourse } from '../../../../global/builders/ap_course_builder';
import { APTermSlotGroup } from '../../../../global/builders/ap_term_slot_group_builder';
import { APYearSlotGroup, IAPYearSlotGroupMeta } from '../../../../global/builders/ap_year_slot_group_builder';
import { IAPAPMarkAsMetStatusDatasource } from '../../../../global/components/mark_as_met/datasources/mark_as_met_status_datasource';
import { IAPCoursesDatasource } from '../../../../global/datasources/ap_courses_datasource';
import { IAPPlannedCourseDataSource } from '../../../../global/datasources/ap_planned_course_datasource';
import { IAPPlannedCourseGroupDatasource } from '../../../../global/datasources/ap_planned_course_group_datasource';
import { IAPProgramSlotDatasource } from '../../../../global/datasources/ap_program_slot_datasource';
import { IAPTermsDatasource } from '../../../../global/datasources/ap_terms_datasource';
import { IAPYearSlotGroupDatasource } from '../../../../global/datasources/ap_year_slot_group_datasource';
import { APGenericSlotServant } from '../../../../global/servants/ap_generic_slot_servant';
import { APProgramSlotServant } from '../../../../global/servants/ap_program_slot_servant';
import { LargeCourseGroupModel } from '../../../../plan/components/large_course_group/models/large_course_group_model';
import { LargeCourseGroupSearchResultModel } from '../../../../plan/components/large_course_group/models/large_course_group_search_result_model';
import { APDegreeMapQueryHelper } from '../../../../plan/queries/ap_degree_map_query_helper';

export interface ILargeCourseGroupSearchResults {
  genericSlots: APGenericSlot[];
}

export interface IAPDegreeMapQueryResult {
  hasDevReqCourses: boolean;
  hasNonDevReqCourses: boolean;
  devReqCourses: APGenericSlot[];
  nonDevReqCourses: APGenericSlot[];
  slotGroupGroups: any;
  hasSlotGroups: boolean;
  yearGroups: APYearSlotGroup[];
  isDegreeMapEmpty: boolean;
}

const termSlotGroupCategorize = (slot: APGenericSlot) => {
  if (APGenericSlotServant.isCourseGroupSlot(slot)) {
    slot.max_credits = slot.programSlot.max_credits;
    slot.min_credits = slot.programSlot.min_credits;
  } else if (APGenericSlotServant.isCourseSlot(slot)) {
    slot.credits = (slot.programSlot._courses as APCourse[])[0].credits;
  }
  return slot;
};

export const categorizeYearGroup = (
  year: APYearSlotGroup & IAPYearSlotGroupMeta,
  nonDevReqGenericSlots: APGenericSlot[]
) => {
  _4.each(year._term_slot_group, (term: APTermSlotGroup) => {
    const programSlots = _4.filter(
      nonDevReqGenericSlots,
      (nonDevReqs) => nonDevReqs.programSlot.term_slot_group === term.id
    );

    _4.each(programSlots, termSlotGroupCategorize);

    term._creditsRange = APProgramSlotServant.getCreditsRange(programSlots);
    term._programSlots = programSlots;
  });
};

export class APDegreeMapQuery implements IQuery {
  private __result: IAPDegreeMapQueryResult;

  constructor(
    QueryMediator: IQueryMediator,
    private ngAPTermsDatasource: IAPTermsDatasource,
    private ngAPPlannedCourseGroupDatasource: IAPPlannedCourseGroupDatasource,
    private ngAPCoursesDatasource: IAPCoursesDatasource,
    private ngAPProgramSlotDatasource: IAPProgramSlotDatasource,
    private ngLargeCourseGroupModel: LargeCourseGroupModel,
    private ngAPDegreeMapQueryHelper: APDegreeMapQueryHelper,
    private ngAPYearSlotGroupDatasource: IAPYearSlotGroupDatasource,
    private ngAPMarkAsMetStatusDatasource: IAPAPMarkAsMetStatusDatasource,
    private ngAPPlannedCoursesDatasource: IAPPlannedCourseDataSource,
    private ngCommentsDatasource: ICommentsDatasource,
    private ngLargeCourseGroupSearchResultModel: LargeCourseGroupSearchResultModel
  ) {
    QueryMediator.registerQuery(
      this,
      ngAPTermsDatasource,
      ngAPCoursesDatasource,
      ngAPPlannedCourseGroupDatasource,
      ngAPProgramSlotDatasource,
      ngLargeCourseGroupModel,
      ngLargeCourseGroupSearchResultModel,
      ngAPMarkAsMetStatusDatasource,
      ngAPPlannedCoursesDatasource,
      ngCommentsDatasource
    );
  }

  run(): this {
    const devReqGenericSlots = this.ngAPDegreeMapQueryHelper.buildDevReqGenericSlots();
    const nonDevReqGenericSlots = this.ngAPDegreeMapQueryHelper.buildNonDevGenericSlots();

    const yearSlotGroupWithMeta = this.ngAPYearSlotGroupDatasource.metasource().derived();
    const yearGroup = _4.toArray(yearSlotGroupWithMeta) as any;

    _4.each(yearGroup, (year: APYearSlotGroup & IAPYearSlotGroupMeta) =>
      categorizeYearGroup(year, nonDevReqGenericSlots)
    );

    const nonGroupedProgramSlots = _4.filter(
      nonDevReqGenericSlots,
      (nonDevReqs: APGenericSlot) => nonDevReqs.programSlot.term_slot_group === null
    );
    if (_4.gt(_4.size(nonGroupedProgramSlots), 0)) {
      yearGroup.push({
        id: undefined,
        nk: '',
        rank: undefined,
        name: 'No Associated Term',
        _term_slot_group: [
          {
            id: undefined,
            name: '',
            year_slot_group: undefined,
            _programSlots: nonGroupedProgramSlots
          }
        ]
      });
    }

    const isDegreeMapEmpty = _4.isEmpty(devReqGenericSlots) && _4.isEmpty(nonDevReqGenericSlots);
    this.__result = {
      hasDevReqCourses: false,
      hasNonDevReqCourses: !_4.isEmpty(nonDevReqGenericSlots),
      devReqCourses: devReqGenericSlots,
      nonDevReqCourses: nonDevReqGenericSlots,
      slotGroupGroups: {},
      isDegreeMapEmpty,
      hasSlotGroups: false,
      yearGroups: _4.sortBy(yearGroup, (year: APYearSlotGroup) => year.rank)
    };

    return this;
  }

  get result(): IAPDegreeMapQueryResult {
    return this.__result;
  }
}

angular.module('capability-ng-academic-planner').service('ngAPDegreeMapQuery', APDegreeMapQuery);



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-academic-planner/src/plan/components/degree_map/queries/ap_degree_map_query.ts